import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getErrorMessage(error, fallback = 'An error occurred') {
  // Handle API validation errors from FastAPI/Pydantic
  if (error.response?.data?.detail) {
    const detail = error.response.data.detail;
    
    // If it's a string, return it directly
    if (typeof detail === 'string') {
      return detail;
    }
    
    // If it's an array of validation errors (Pydantic format)
    if (Array.isArray(detail)) {
      return detail.map(err => {
        if (typeof err === 'string') return err;
        if (err.msg) return err.msg;
        if (err.message) return err.message;
        return JSON.stringify(err);
      }).join(', ');
    }
    
    // If it's an object, try to extract message
    if (typeof detail === 'object' && detail.msg) {
      return detail.msg;
    }
  }
  
  // Fallback to other common error formats
  return error.response?.data?.message || error.message || fallback;
}
